import React, { useState } from "react";
import styles from "./update-flight.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useGetFlightQuery } from "../flightApi";
import { ReactComponent as EditIcon } from "./assets/edit.svg";
import { Tooltip } from "../../../../../ui/tooltip/Tooltip";
import { IconButton } from "../../../../../ui/iconButton/IconButton";
import { Button } from "../../../../../ui/button/Button";
import { EditFlight } from "../editFlight/editFlight";
import WorksCompletedTable from "../../worksCompleted/worksCompletedTable";
import { WorkCost } from "../../workCost/workCost";
import { PilotsTable } from "../../pilots/pilotsTable";
import { ReviewTable } from "../../review/reviewTable";
import { min2HHMM } from "../../../../../helpers/time";

const UpdateFlight = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const {
    data: flight,
    isFetching: isFlightFetching,
    isError: isFlightError,
  } = useGetFlightQuery(Number(id));

  const edit = () => {
    setIsEditOpen(true);
  };

  if (!id) {
    return null;
  }
  const back = () => {
    navigate(-1);
  };
  return (
    <div className={styles.main}>
      <div className={styles.actions}>
        <Button onClick={back}>{`< Назад`}</Button>
      </div>
      <h2 className={styles.title}>Редактирование налета</h2>
      <section className={styles.flight}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Дата и время вылета</th>
              <th>Авиаотделение</th>
              <th>Длительность</th>
              <th>№ договора</th>
              <th>Дата и время прилета</th>
              <th>Тип ВС</th>
              <th>Бортовой номер</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{flight?.date_start}</td>
              <td>{flight?.airbase_name}</td>
              <td>{ flight?.duration ? min2HHMM(flight?.duration) : " - "}</td>
              <td>{flight?.contract_name}</td>
              <td>{flight?.date_end}</td>
              <td>{flight?.transport_name}</td>
              <td>{flight?.transport_number}</td>
              <td>
                <Tooltip label="Редактировать запись">
                  <IconButton onClick={edit}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div className={styles.devider} />
      <WorksCompletedTable />
      <div className={styles.devider} />
      <PilotsTable />
      <div className={styles.devider} />
      <ReviewTable />
      <div className={styles.devider} />
      <WorkCost />
      {isEditOpen && (
        <EditFlight close={() => setIsEditOpen(false)} id={Number(id)} />
      )}
    </div>
  );
};

export default UpdateFlight;
